<p-dialog
   header="Edit schedule"
   [(visible)]="service.dayDialogVisible"
   [modal]="true"
   [draggable]="false"
   [resizable]="false"
   class="vsp-dialog"
   (onShow)="onDialogShow()"
   (onHide)="onDialogHide()">
   <ng-container *ngIf="service.dayDialogVisible">
      <ng-container *ngIf="service.isWorkDay()">
         <div class="instructions-container">
            <div class="instructions-text">
               To add a doctor shift, enter the
               <strong>Start Time</strong>
               ,
               <strong>End Time</strong>
               , and
               <strong>Category</strong>
               , then select
               <strong>"Add."</strong>
               Repeat these steps for each additional shift and select
               <strong>"Save"</strong>
               when finished. Shifts cannot overlap, so ensure all shift times are unique.
            </div>
            <div class="examples-wrapper">
               <div class="example-section">
                  <div class="example-header">Standard Example</div>
                  <ul class="shift-list">
                     <li>
                        <strong>Shift 1:</strong>
                        12:00 PM – 1:00 PM
                     </li>
                     <li>
                        <strong>Shift 2:</strong>
                        2:01 PM – 3:00 PM
                     </li>
                  </ul>
               </div>
               <div class="example-section highlight">
                  <div class="example-header">
                     24 HR Hospitals
                     <span
                        class="section-subtitle"
                        style="float: right">
                        Shifts should be split by day
                     </span>
                  </div>
                  <div
                     class="section-subtitle"
                     style="margin-top: -2px; font-style: normal; font-weight: 500">
                     Overnight Shift Example:
                  </div>
                  <ul class="shift-list">
                     <li>
                        <strong>Shift Monday:</strong>
                        7:00 PM – 11:59 PM
                     </li>
                     <li>
                        <strong>Shift Tuesday:</strong>
                        12:00 AM – 3:00 AM
                     </li>
                  </ul>
               </div>
            </div>
         </div>

         <div class="form-section">
            <div class="form-section-header">Add New Shift</div>

            <div class="form-row">
               <div class="form-group">
                  <label
                     class="form-label"
                     for="category">
                     Category
                  </label>
                  <p-select
                     inputId="category"
                     [options]="stChoices"
                     appendTo="body"
                     placeholder="Select a category"
                     [optionValue]="'value'"
                     [(ngModel)]="shiftType"
                     styleClass="form-select-wrapper"></p-select>
               </div>

               <div
                  class="form-group"
                  *ngIf="!isTimelessShiftType()">
                  <label
                     class="form-label"
                     for="start-time">
                     Start Time
                  </label>
                  <p-datepicker
                     inputId="start-time"
                     [timeOnly]="true"
                     appendTo="body"
                     [(ngModel)]="startTime"
                     stepMinute="15"
                     (ngModelChange)="onTimeChange(startTime)"
                     hourFormat="12"
                     styleClass="form-input-wrapper"></p-datepicker>
               </div>

               <div
                  class="form-group"
                  *ngIf="!isTimelessShiftType()">
                  <label
                     class="form-label"
                     for="end-time">
                     End Time
                  </label>
                  <p-datepicker
                     inputId="end-time"
                     [timeOnly]="true"
                     appendTo="body"
                     [(ngModel)]="endTime"
                     stepMinute="15"
                     (ngModelChange)="onTimeChange(endTime); onEndTimeChange()"
                     hourFormat="12"
                     styleClass="form-input-wrapper"></p-datepicker>
               </div>
               @if (!editedShift()) {
                  <button
                     (click)="addShift()"
                     [disabled]="!isShiftValid()"
                     class="btn-add">
                     Add
                  </button>
               }
               @if (editedShift()) {
                  <button
                     (click)="cancelEditShift()"
                     class="btn-add btn-red">
                     Cancel
                  </button>
                  <button
                     (click)="saveEditedShift()"
                     [disabled]="!isShiftValid()"
                     class="btn-add">
                     Save
                  </button>
               }
            </div>

            <!-- Table -->
            <div class="table-container">
               <p-table [value]="shifts()">
                  <ng-template pTemplate="header">
                     <tr>
                        <th>Category</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                        <th>Actions</th>
                     </tr>
                  </ng-template>
                  <ng-template
                     pTemplate="body"
                     let-shift>
                     <tr>
                        <td>{{ shift.typeName }}</td>
                        <td>{{ shift.startTimeDate | date: "shortTime" }}</td>
                        <td>{{ shift.endTimeDate | date: "shortTime" }}</td>
                        <td>
                           <button
                              (click)="editShift(shift)"
                              class="btn-remove btn-green mr-2">
                              <i class="fa fa-pencil"></i>
                              &nbsp;&nbsp;Edit
                           </button>
                           <button
                              (click)="removeShift(shift)"
                              class="btn-remove">
                              <i class="fa fa-trash-can"></i>
                              &nbsp;&nbsp;Remove
                           </button>
                        </td>
                     </tr>
                  </ng-template>
               </p-table>
            </div>
         </div>
      </ng-container>
      <div
         *ngIf="!service.isWorkDay()"
         class="row g-3 mt-3"
         style="min-width: 400px">
         <div class="col">
            <vc-radio-group
               direction="column"
               label="Reason"
               [options]="dtChoices"
               [(ngModel)]="dayType"
               (ngModelChange)="onRadioGroupChange($event)"></vc-radio-group>
         </div>
      </div>

      <ng-template pTemplate="footer">
         @if (service.isWorkDay()) {
            <div
               class="d-flex"
               style="flex-grow: 1">
               <vc-multi-select
                  class="to-others-drop mr-3"
                  appendTo="body"
                  label="Copy to doctors"
                  [options]="doctors()"
                  optionLabel="label"
                  [(selectedItems)]="copyToDoctors"
                  selectedItemsLabel="{0} doctors selected"></vc-multi-select>
               <vc-multi-select
                  appendTo="body"
                  class="to-others-drop"
                  label="Copy to days"
                  [options]="daysOfWeek()"
                  optionLabel="label"
                  [(selectedItems)]="copyToDays"
                  selectedItemsLabel="{0} days selected"></vc-multi-select>
            </div>

            <button
               (click)="cancel()"
               class="v-button v-button-md v-darkgreen-border m-1 mt-3 mb-3">
               Cancel
            </button>
            <button
               (click)="save()"
               [disabled]="!isValid()"
               class="v-button v-button-md v-darkgreen m-1 mt-3 mb-3">
               Save
            </button>
         }
      </ng-template>
   </ng-container>
</p-dialog>
